<template>
    <div id="Transcripcion">
        <header class="cont-tit">
            <h2 class="tit">Transcripción</h2>
            <div class="description-card">
                <div class="card-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="card-content">
                    <p class="bajada">
                        El repertorio de frases que encontrarás acá se obtuvo a partir del libro '5000 frases precocinadas para textos científicos', del grupo NeoScientia, a cargo de Pedro Margollés García (
                        <a href="https://neuroscientia.com" target="_blank" rel="noopener noreferrer">
                        neuroscientia.com
                        </a>
                        )
                    </p>
                </div>
            </div>
        </header>
        <div class="wrapper">
            <FormulateForm class="filterbar" @submit="submitHandler" #default="{ isLoading }">
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="text"
                                name="patron"
                                label="Patrón"
                                label-class="control-label"
                                placeholder="Patrón"
                                v-model="patron"
                                v-if="seen"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="select"
                                name="anio"
                                label="Año"
                                label-class="control-label"
                                placeholder="Seleccione"
                                :options="optionsTipoAnio"
                                v-model="anio"
                                v-if="seen"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                                type="select"
                                name="funcs"
                                label="Función"
                                label-class="control-label"
                                placeholder="Seleccione"
                                :options="optionsFunciones"
                                v-model="funciones"
                                @change="change_trigger"
                        />
                    </div>

                </div>
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                            type="select"
                            name="mm_select"
                            label="Macromovida"
                            label-class="control-label"
                            placeholder="Seleccione"
                            :options="optionsTipoMM"
                            v-model="MM"
                            @change="change_trigger2"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <FormulateInput
                            type="select"
                            name="mm_select"
                            label="Pasos"
                            label-class="control-label"
                            placeholder="Seleccione"
                            :options="optionsPasos"
                            :select-size="4"
                            v-model="Pasos"
                            v-if="seen"
                        />
                    </div>
                </div>
                <FormulateInput
                        type="submit"
                        :disabled="isLoading"
                        :label="isLoading ? 'Cargando...' : 'BUSCAR'"
                        class="formulate-input"
                        v-b-modal.modal-xl-transcripcion
                />

            </FormulateForm>

            <!-- <div class="accordion" role="tablist" id="accordion1">
              <span v-html="resIndice"></span>
            </div> -->
            <b-modal id="modal-xl-transcripcion" size="xl" :title="funciones" hide-footer>
                <div class="accordion" role="tablist" id="accordionTranscripcion">
                    <b-card v-for="(item, index) in resIndice2" v-bind:key="index" no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button block v-b-toggle="`collapse-${ index }-Transcripcion`" variant="info">{{ item.title }}</b-button>
                        </b-card-header>
                        <b-collapse :id="`collapse-${ index }-Transcripcion`" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text v-html="item.paper_index"></b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "TabTranscripcion",
    data() {
        return {
            seen: false,
            resIndice: null,
            resIndice2: [{'title':'','paper_index':''}],
            patron: null,
            anio: "null",
            MM: null,
            Pasos: null,
            funciones: null,
            optionsFunciones:[
                {value: 'Patrones de propósitos', label:"Patrones de propósitos"},
                {value: 'Similitud de propósitos', label:"Similitud de propósitos"},
                {value: 'Banco de frases', label:"Banco de frases"},
                //{value: 'Revisión de objetivo', label:"Revisión de objetivo"},

            ],
            optionsTipoAnio: [
                { value: "null", label: "Todos los años" },
                { value: "2007", label: "2007" },
                { value: "2008", label: "2008" },
                { value: "2009", label: "2009" },
                { value: "2010", label: "2010" },
                { value: "2011", label: "2011" },
                { value: "2012", label: "2012" },
                { value: "2013", label: "2013" },
                { value: "2014", label: "2014" },
                { value: "2015", label: "2015" },
                { value: "2016", label: "2016" },
                { value: "2017", label: "2017" },
                { value: "2018", label: "2018" },
                { value: "2019", label: "2019" },
                { value: "2020", label: "2020" },
                { value: "2021", label: "2021" },

            ],
            optionsTipoMM: [
                { value: "null", label: "-" },

            ],
            optionsPasos: [
                { value: "null", label: "-" },

            ],
        };
    },
    methods: {
        async submitHandler() {
            let loader = this.$loading.show({ isFullPage: true, canCancel: false });
            try {
                const formData = new FormData();
                formData.append("patron", this.patron);
                formData.append("anio", this.anio);
                formData.append("funciones", this.funciones);
                formData.append("macromove", this.MM)
                formData.append("pasos", this.Pasos)
                let res = await axios.post(
                    `${process.env.VUE_APP_API_URL}/api/Transcripcion`,
                    formData
                );
                this.resIndice = res.data.html_response;
                // Si es un array, para cada uno de sus elementos, limpiar el campo paper_index para dejar solo texto plano
                const context2 = res.data.context2.map(item => {
                    item.paper_index = item.paper_index
                        .replace(/<[^>]*>?/g, '')
                        .split(/[.!?]+\s+/)
                        .filter(sentence => sentence.trim().length > 0)
                        .map(sentence => `• ${sentence.trim()}`)
                        .join('<br>');
                    return item;
                });
                this.resIndice2 = context2;
                this.makeToast(
                    "Mostrar Indice realizado exitosamente.",
                    "success"
                );
            } catch (err) {
                console.warn(err);
                this.makeToast(err, "danger");
            }
            loader.hide();
        },
        makeToast(message, variant) {
            let title =
                variant == "success" ? "Operación exitosa" : "Operación fallida";
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: false,
                autoHideDelay: 2000,
            });
        },
        change_trigger: function () {

            if (this.funciones === 'Patrones de propósitos' || this.funciones === 'Similitud de propósitos') {
                this.seen = true;

                this.optionsTipoMM = [
                    {value: "null", label: "-"},
                    {value: "introduccion", label: "Introducción"},
                    {value: "invprev", label: "Investigaciones Previas"},
                    {value: "metodologia", label: "Metodología"},
                    {value: "resultados", label: "Resultados"},
                    {value: "conclusion", label: "Conclusión"}
                ];
            }

            else if (this.funciones === 'Banco de frases') {
                this.seen = false;

                this.optionsTipoMM = [
                    {value: "null", label: "-"},
                    {value: "agradecimientos", label: "Agradecimientos"},
                    {value: "sobre_los_autores", label: "Sobre los autores"},
                    {value: "discusion", label: "Discusión"},
                    {value: "resultados", label: "Resultados"},
                    {value: "mat_y_metodos", label: "Materiales y Métodos"},
                    {value: "introduccion", label: "Introducción"},
                    {value: "abstract_y_conclusiones", label: "Abstract y Conclusiones"},

                ];
            }
        },
        change_trigger2() {
            if (this.funciones === 'Patrones de propósitos' || this.funciones === 'Similitud de propósitos') {

                if (this.MM === 'introduccion') {

                    this.optionsPasos = [
                        {value: "null", label: "-"},
                        {value: "MM1M1P1", label: "Generalización del tópico con especificidad creciente"},
                        {value: "MM1M2P1", label: "Indicación del vacío"},
                        {value: "MM1M3P1", label: "Anuncio del objetivo de la investigación"},
                        {value: "MM1M3P2", label: "Clarificación de algunas definiciones"},
                    ];
                }

                else if (this.MM === 'invprev') {
                    this.optionsPasos = [
                        {value: "null", label: "-"},
                        {value: "MM2M1P1", label: "Presentación de la estructura y/o contenidos a tratar"},
                        {
                            value: "MM2M2P1",
                            label: "Presentación del estado actual del conocimiento y prácticas no investigadas"
                        },
                        {value: "MM2M2P2", label: "Afirmación de la centralidad del tema"},

                    ];
                }

                else if (this.MM === 'metodologia') {
                    this.optionsPasos = [
                        {value: "null", label: "-"},
                        {value: "MM3M1P1", label: "Presentación de la estructura o contenidos del marco metodológico"},
                        {value: "MM3M2P1", label: "Presentación de objetivos"},
                        {value: "MM3M3P1", label: "Descripción de participantes y/ o materiales"},
                        {value: "MM3M3P2", label: "Ubicación y características contextuales de la muestra"},
                        {value: "MM3M4P1", label: "Detalle de los procedimientos de recolección de datos"},
                    ];
                }

                else if (this.MM === 'resultados') {
                    this.optionsPasos = [
                        {value: "null", label: "-"},
                        {value: "MM4M1P1", label: "Presentación de la estructura y/o contenidos a tratar"},
                        {
                            value: "MM4M2P1",
                            label: "Presentación de los resultados por medio de recursos verbales y no verbales"
                        },
                        {value: "MM4M3P1", label: "Interpretación de datos obtenidos"},
                        {value: "MM4M3P2", label: "Comparación de resultados con la literatura"},
                        {value: "MM4M3P3", label: "Evaluación de resultados y hallazgos"},
                    ];
                }

                else if (this.MM === 'conclusion') {
                    this.optionsPasos = [
                        {value: "null", label: "-"},
                        {value: "MM5M1P1", label: "Generalización del tópico con especificidad creciente"},
                        {value: "MM5M1P2", label: "Indicación del vacío"},
                        {value: "MM5M2P1", label: "Anuncio del objetivo de la investigación"},
                        {value: "MM5M2P2", label: "Clarificación de algunas definiciones"},
                    ];
                }
            }
            else {
                this.optionsPasos = [];
            }
            if (this.funciones === 'Banco de frases') {
                this.seen = false;
            }
        },
    },
};
</script>

<style scoped>
/* Description Card Styles */
.description-card {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--background-color);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  margin-top: 1rem;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
}

.description-card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--primary-color);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--primary-color);
  color: white;
  border-radius: var(--radius-sm);
  flex-shrink: 0;
}

.card-content {
  flex: 1;
  min-width: 0;
}

.bajada {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.bajada a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.bajada a:hover {
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .description-card {
    padding: 0.875rem;
    gap: 0.625rem;
  }
  
  .card-icon {
    width: 28px;
    height: 28px;
  }
  
  .bajada {
    font-size: 0.8125rem;
  }
}

@media (max-width: 480px) {
  .description-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .card-icon {
    align-self: flex-start;
  }
}
</style>